import { Button, ClipboardListIcon } from "@datagame/ui";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import { isWordPresent } from "../../../utils/isWordPresent";
import { useWordopolis } from "../../../hooks/useWordopolis";
import { WordopolisActionKind } from "../../../reducers/wordopolis";

import styles from "./WordopolisMobileBottom.module.scss";

const cx = classNames.bind(styles);

const randomStringBasedOnWord = (word: string) => {
  const randomString = word.split("").map(() => String.fromCharCode(65 + Math.floor(Math.random() * 26)));
  return randomString;
};

export const WordopolisMobileBottom = () => {
  const [
    {
      configuration: { words: wordsPlacements, gameVisuals },
      status: { foundWords, isGameFinished },
    },
    dispatch,
  ] = useWordopolis();
  const { themeColor } = gameVisuals || {};
  const words = wordsPlacements.map(({ value }) => value);
  const { t: translate } = useTranslation();
  const t = (key: string) => translate(`wordopolis.${key}`);
  const wordTags = words.map((word) => ({
    word,
    isFound: isWordPresent(word, foundWords),
  }));
  const sortedWords = wordTags.sort((a, b) => Number(b.isFound) - Number(a.isFound));

  return (
    <div className={styles.wordopolisMobileBottom}>
      <div className={styles.foundWords}>
        <h3 className={styles.foundWordsLabel}>{t("foundWords")} </h3>
        <div className={styles.foundWordsTagList}>
          {sortedWords.map(({ word, isFound }) => (
            <span className={cx("wordTag", { found: isFound })} key={word}>
              {isFound ? word.toUpperCase() : randomStringBasedOnWord(word)}
            </span>
          ))}
        </div>
      </div>

      <Button
        iconSide="left"
        icon={<ClipboardListIcon />}
        customColor={themeColor}
        disabled={isGameFinished}
        onClick={() => dispatch({ type: WordopolisActionKind.TOGGLE_SHOW_WORDS })}
      >
        {t("wordList")}
      </Button>
    </div>
  );
};
